import { useShopPaymentMethodsQuery } from '../queries/useShopPaymentMethodsQuery';
export const useShopPaymentMethods = () => {
    const { shopPaymentMethodsQuery } = useShopPaymentMethodsQuery();
    const defaultPaymentMethod = shopPaymentMethodsQuery.data?.result.find((creditCard) => creditCard.default);
    return {
        hasActivePaymentMethod: !!defaultPaymentMethod && defaultPaymentMethod.status !== 'FAILED',
    };
};
